import React from 'react';
import FitRow from '../components/UI/fitrow/FitRow';
import ValueText from '../components/UI/value_text/ValueText';

const Fit = () => {
  return (
    <div> 
        <h2>Итог дня</h2>
        <FitRow>
          <ValueText props={{name:"т1: ",  varName: "tf1_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т2: ",  varName: "tf2_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т3: ",  varName: "tf3_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т4: ",  varName: "tf4_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"КНС: ", varName: "tf5_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"Σ: ", varName: "tf_sum_day", meas: "м³" , digits:"0"}} />
        </FitRow>
        <h2>Вчерашний итог</h2>
        <FitRow>
          <ValueText props={{name:"т1: ",  varName: "tf1_prev_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т2: ",  varName: "tf2_prev_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т3: ",  varName: "tf3_prev_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т4: ",  varName: "tf4_prev_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"КНС: ", varName: "tf5_prev_day", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"Σ: ", varName: "tf_sum_prev_day", meas: "м³" , digits:"0"}} />
        </FitRow>
        <h2>Общий итог</h2>
        <FitRow>
          <ValueText props={{name:"т1: ",  varName: "tf1_base", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т2: ",  varName: "tf2_base", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т3: ",  varName: "tf3_base", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"т4: ",  varName: "tf4_base", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"КНС: ", varName: "tf5_base", meas: "м³" , digits:"0"}} />
          <ValueText props={{name:"Σ: ", varName: "tf_sum_base", meas: "м³" , digits:"0"}} />
        </FitRow>
    </div>
  )
}

export default Fit